import script from "./ShakyoSmartMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakyoSmartMenu.vue?vue&type=script&setup=true&lang=js"

import "./ShakyoSmartMenu.vue?vue&type=style&index=0&id=db99d7ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db99d7ea"]])

export default __exports__